export default __webpack_public_path__ + "static/discover-damixa--white-en-587617e37dda4d465e52e38f6e3503a8.svg";